export type Lang = "en" | "zh";

let currentLang: Lang = "zh";

export function getLang(): Lang {
  return currentLang;
}

export function toggleLang(): Lang {
  currentLang = currentLang === "en" ? "zh" : "en";
  return currentLang;
}

const strings = {
  welcome: { en: "Welcome to the dungeon. Find the Amulet on depth 10 and ascend!", zh: "欢迎来到地牢，在第10层找到护身符并返回地面！" },
  noStairs: { en: "There are no stairs here.", zh: "这里没有楼梯。" },
  noStairsUp: { en: "There are no stairs up here.", zh: "这里没有上行楼梯。" },
  descend: { en: (d: number) => `You descend to depth ${d}.`, zh: (d: number) => `你下到了第${d}层。` },
  ascend: { en: (d: number) => `You ascend to depth ${d}.`, zh: (d: number) => `你上到了第${d}层。` },
  escaped: { en: "You escaped the dungeon with the Amulet! You win!", zh: "你带着护身符逃出了地牢！你赢了！" },
  youHit: { en: (name: string, dmg: number) => `You hit the ${name} for ${dmg} damage.`, zh: (name: string, dmg: number) => `你对${name}造成了${dmg}点伤害。` },
  monsterDies: { en: (name: string) => `The ${name} dies!`, zh: (name: string) => `${name}死了！` },
  monsterHitsYou: { en: (name: string, dmg: number) => `The ${name} hits you for ${dmg} damage!`, zh: (name: string, dmg: number) => `${name}对你造成了${dmg}点伤害！` },
  youDied: { en: "You died! Press R to restart.", zh: "你死了！按R重新开始。" },
  drinkPotion: { en: (name: string, hp: number) => `You drink a ${name}. (+${hp} HP)`, zh: (name: string, hp: number) => `你喝了${name}。(+${hp} 生命)` },
  useWeapon: { en: (name: string, atk: number) => `You use the ${name}. (+${atk} ATK)`, zh: (name: string, atk: number) => `你使用了${name}。(+${atk} 攻击)` },
  foundAmulet: { en: "You found the Amulet of Yendor! Now ascend to the surface!", zh: "你找到了延多护身符！现在返回地面！" },
  youWin: { en: "YOU WIN!", zh: "你赢了！" },
  youDiedTitle: { en: "YOU DIED", zh: "你死了" },
  pressR: { en: "Press R to restart", zh: "按R重新开始" },
  pressRMobile: { en: "Tap to restart", zh: "点击重新开始" },
  hp: { en: "HP", zh: "生命" },
  atk: { en: "ATK", zh: "攻击" },
  def: { en: "DEF", zh: "防御" },
  depth: { en: "Depth", zh: "层数" },
  turn: { en: "Turn", zh: "回合" },
  autoExplore: { en: "Auto-exploring...", zh: "自动探索中……" },
  autoStop: { en: "Stopped.", zh: "已停止。" },
  autoMonster: { en: "Stopped: monster spotted!", zh: "已停止：发现怪物！" },
  autoItem: { en: "Stopped: found an item.", zh: "已停止：发现物品。" },
  autoStairs: { en: "Stopped: found stairs.", zh: "已停止：发现楼梯。" },
  autoToStairs: { en: "Exploration complete. Heading to downstairs...", zh: "探索完成，正在前往下楼梯……" },
  autoDone: { en: "Nothing left to explore.", zh: "没有可探索的区域了。" },
  monsterDrops: { en: (name: string) => `The ${name} dropped something!`, zh: (name: string) => `${name}掉落了物品！` },
  waterSlow: { en: "You wade through the water...", zh: "你在水中艰难前行……" },
  grassHide: { en: "You hide in the tall grass.", zh: "你隐藏在草丛中。" },
  nothingHere: { en: "There is nothing to pick up here.", zh: "这里没有可拾取的物品。" },
  inventoryFull: { en: "Your inventory is full!", zh: "背包已满！" },
  pickUpItem: { en: (name: string) => `You pick up the ${name}.`, zh: (name: string) => `你拾取了${name}。` },
  itemOnGround: { en: (name: string) => `You see a ${name} here. (g to pick up)`, zh: (name: string) => `你看到这里有${name}。(按g拾取)` },
  equipItem: { en: (name: string) => `You equip the ${name}.`, zh: (name: string) => `你装备了${name}。` },
  unequipItem: { en: (name: string) => `You unequip the ${name}.`, zh: (name: string) => `你卸下了${name}。` },
  itemBreaks: { en: (name: string) => `Your ${name} breaks!`, zh: (name: string) => `你的${name}损坏了！` },
  useTeleport: { en: "You teleport to a new location!", zh: "你传送到了新位置！" },
  identify: { en: (name: string, dur: number, max: number) => `${name}: durability ${dur}/${max}`, zh: (name: string, dur: number, max: number) => `${name}：耐久度 ${dur}/${max}` },
  identifyNothing: { en: "Nothing to identify.", zh: "没有可鉴定的物品。" },
  identifyReveal: { en: (name: string) => `Identified: ${name}!`, zh: (name: string) => `鉴定出：${name}！` },
  drinkStrength: { en: (val: number) => `You feel stronger! (+${val} ATK)`, zh: (val: number) => `你感到更强壮了！(+${val} 攻击)` },
  drinkPoison: { en: (dmg: number) => `It's poison! (-${dmg} HP)`, zh: (dmg: number) => `是毒药！(-${dmg} 生命)` },
  enchantWeapon: { en: (name: string) => `Your ${name} glows brightly! (+1 ATK)`, zh: (name: string) => `你的${name}闪耀着光芒！(+1 攻击)` },
  enchantNothing: { en: "You have no weapon equipped.", zh: "你没有装备武器。" },
  useMapping: { en: "The entire floor is revealed!", zh: "整层地图都显示了！" },
  throwHint: { en: "Press a direction to throw.", zh: "按方向键投掷。" },
  throwHit: { en: (item: string, target: string, dmg: number) => `The ${item} hits the ${target} for ${dmg} damage!`, zh: (item: string, target: string, dmg: number) => `${item}命中了${target}，造成${dmg}点伤害！` },
  throwMiss: { en: (item: string) => `The ${item} flies into the darkness.`, zh: (item: string) => `${item}飞入了黑暗中。` },
  bombExplode: { en: "The bomb explodes!", zh: "炸弹爆炸了！" },
  bombHits: { en: (count: number) => `The blast hits ${count} monster${count === 1 ? "" : "s"}!`, zh: (count: number) => `爆炸命中了${count}个怪物！` },
  bombSelf: { en: (dmg: number) => `You are caught in the blast! (-${dmg} HP)`, zh: (dmg: number) => `你被爆炸波及了！(-${dmg} 生命)` },
  bombPet: { en: (dmg: number) => `Your pet is caught in the blast! (-${dmg} HP)`, zh: (dmg: number) => `你的宠物被爆炸波及了！(-${dmg} 生命)` },
  dropItem: { en: (name: string) => `You drop the ${name}.`, zh: (name: string) => `你丢弃了${name}。` },
  eat: { en: (name: string, val: number) => `You eat the ${name}. (+${val} satiety)`, zh: (name: string, val: number) => `你吃了${name}。(+${val} 饱食度)` },
  hungry: { en: "You are getting hungry...", zh: "你感到饥饿……" },
  starving: { en: "You are starving! (-1 HP)", zh: "你正在挨饿！(-1 生命)" },
  inventoryTitle: { en: "INVENTORY", zh: "背包" },
  inventoryHint: { en: "Tap row to select. Enter/use, d/drop, Esc/close.", zh: "点击条目选择。回车/使用，d/丢弃，Esc/关闭。" },
  invUseBtn: { en: "Use", zh: "使用" },
  invDropBtn: { en: "Drop", zh: "丢弃" },
  invCloseBtn: { en: "Close", zh: "关闭" },
  emptyInventory: { en: "(empty)", zh: "(空)" },
  equipped: { en: "Equipped", zh: "已装备" },
  hunger: { en: "Food", zh: "饱食" },
  snakePoison: { en: "The venom courses through you!", zh: "蛇毒侵入了你的身体！" },
  ogreKnockback: { en: "The ogre knocks you back!", zh: "食人魔将你击退了！" },
  ogreSlow: { en: "You feel sluggish...", zh: "你感到行动迟缓……" },
  ghostBlind: { en: "The ghost's touch clouds your vision!", zh: "幽灵的触碰模糊了你的视野！" },
  dragonBleed: { en: "The dragon's claws tear into you!", zh: "巨龙的利爪撕裂了你！" },
  slowedMove: { en: "You struggle to move...", zh: "你艰难地移动……" },
  slimeSplit: { en: "The slime splits into smaller pieces!", zh: "史莱姆分裂成了小块！" },
  lichSummon: { en: "The lich raises the dead!", zh: "巫妖召唤了亡灵！" },
  lichBlind: { en: "The lich's dark magic clouds your vision!", zh: "巫妖的黑暗魔法蒙蔽了你的视野！" },
  enchantBurn: { en: "Your weapon sets the enemy ablaze!", zh: "你的武器将敌人点燃了！" },
  enchantFreeze: { en: "Your weapon freezes the enemy!", zh: "你的武器冻住了敌人！" },
  vampiricHeal: { en: (hp: number) => `You drain life from the fallen. (+${hp} HP)`, zh: (hp: number) => `你从倒下的敌人身上汲取了生命力。(+${hp} 生命)` },
  thornsReflect: { en: (dmg: number) => `Thorns reflect ${dmg} damage!`, zh: (dmg: number) => `荆棘反射了${dmg}点伤害！` },
  wraithDrain: { en: "The wraith drains your life force! (-1 max HP)", zh: "幽灵吸取了你的生命力！(-1 最大生命)" },
  fireImpAttack: { en: (dmg: number) => `The fire imp hurls a fireball for ${dmg} damage!`, zh: (dmg: number) => `火焰小鬼投掷了火球，造成${dmg}点伤害！` },
  skeletonReassemble: { en: "A skeleton reassembles itself!", zh: "骷髅重新拼合了自己！" },
  abilityUnlock: { en: (name: string) => `Ability unlocked: ${name}!`, zh: (name: string) => `解锁技能：${name}！` },
  abilityCooldown: { en: (turns: number) => `Ability on cooldown (${turns} turns).`, zh: (turns: number) => `技能冷却中（${turns}回合）。` },
  noTarget: { en: "No target in range.", zh: "范围内没有目标。" },
  shieldBash: { en: (name: string) => `You bash the ${name}, stunning it!`, zh: (name: string) => `你猛击了${name}，将其击晕！` },
  battleCry: { en: (count: number) => `You let out a battle cry! ${count} enemies flee in terror!`, zh: (count: number) => `你发出战吼！${count}个敌人惊恐逃窜！` },
  dashHit: { en: (name: string, dmg: number) => `You dash through the ${name} for ${dmg} damage!`, zh: (name: string, dmg: number) => `你冲刺穿过${name}，造成${dmg}点伤害！` },
  shopBuy: { en: (item: string, price: number) => `Buy ${item} for ${price} gold? (y/n)`, zh: (item: string, price: number) => `花${price}金币购买${item}？(y/n)` },
  shopBought: { en: (item: string) => `You bought the ${item}.`, zh: (item: string) => `你购买了${item}。` },
  shopNoGold: { en: "Not enough gold!", zh: "金币不足！" },
  shopkeeperGreet: { en: "The shopkeeper nods at you.", zh: "店主向你点了点头。" },
  equipCursed: { en: "The equipment feels wrong... it's cursed!", zh: "装备感觉不对劲……它被诅咒了！" },
  cursedSlot: { en: "A cursed item is stuck in that slot!", zh: "该装备栏被诅咒的物品占据了！" },
  removeCurse: { en: "The curse has been lifted!", zh: "诅咒已被解除！" },
  removeCurseNone: { en: "Nothing happens.", zh: "什么也没发生。" },
  identifyCursed: { en: (name: string) => `Your ${name} is cursed!`, zh: (name: string) => `你的${name}被诅咒了！` },
  lavaDamage: { en: "The lava scorches you! (-3 HP)", zh: "岩浆灼伤了你！(-3 生命)" },
  burningGrassDmg: { en: "The fire burns you! (-2 HP)", zh: "火焰灼伤了你！(-2 生命)" },
  durabilityWarning: { en: "Your equipment is wearing thin!", zh: "你的装备快要损坏了！" },
  archerShoot: { en: (name: string, dmg: number) => `The ${name} shoots you for ${dmg} damage!`, zh: (name: string, dmg: number) => `${name}射中了你，造成${dmg}点伤害！` },
  statusDamage: { en: (dmg: number) => `You take ${dmg} damage from status effects.`, zh: (dmg: number) => `你因状态效果受到${dmg}点伤害。` },
  levelUp: { en: (lv: number) => `Level up! You are now level ${lv}. Choose: 1=HP 2=ATK 3=DEF`, zh: (lv: number) => `升级了！你现在是${lv}级。选择：1=生命 2=攻击 3=防御` },
  levelupConfirmBtn: { en: "Confirm", zh: "确认" },
  levelupHint: { en: "Tap to select, then confirm. D-pad/arrows + Enter/Wait also work.", zh: "点击选择后确认。也可用方向键/十字键 + 回车/等待键。" },
  levelHp: { en: "Max HP increased by 5!", zh: "最大生命值增加了5！" },
  levelAtk: { en: "Attack increased by 1!", zh: "攻击力增加了1！" },
  levelDef: { en: "Defense increased by 1!", zh: "防御力增加了1！" },
  xpLabel: { en: "XP", zh: "经验" },
  lvLabel: { en: "Lv", zh: "等级" },
  trapSpike: { en: (dmg: number) => `You step on a spike trap! (-${dmg} HP)`, zh: (dmg: number) => `你踩到了地刺陷阱！(-${dmg} 生命)` },
  trapTeleport: { en: "A teleport trap activates!", zh: "传送陷阱被触发了！" },
  trapAlarm: { en: "An alarm trap sounds! Monsters appear!", zh: "警报陷阱响了！怪物出现了！" },
  killsLabel: { en: "Kills", zh: "击杀" },
  leaderboard: { en: "LEADERBOARD", zh: "排行榜" },
  savedGame: { en: "Game saved.", zh: "游戏已保存。" },
  loadedGame: { en: "Save loaded.", zh: "已读取存档。" },
  petHeals: { en: (hp: number) => `Jack heals itself. (+${hp} HP)`, zh: (hp: number) => `Jack治愈了自己。(+${hp} 生命)` },
  petAttacks: { en: (target: string, dmg: number) => `Jack bites the ${target} for ${dmg} damage!`, zh: (target: string, dmg: number) => `Jack咬了${target}，造成${dmg}点伤害！` },
  petKills: { en: (target: string) => `Jack kills the ${target}!`, zh: (target: string) => `Jack杀死了${target}！` },
  petDied: { en: "Jack has fallen...", zh: "Jack倒下了……" },
  petHurt: { en: (attacker: string, dmg: number) => `The ${attacker} hits Jack for ${dmg} damage!`, zh: (attacker: string, dmg: number) => `${attacker}对Jack造成了${dmg}点伤害！` },
  wolfPackBonus: { en: (n: number) => `Pack bonus! (+${n} ATK)`, zh: (n: number) => `群狼加成！(+${n} 攻击)` },
  spiderWeb: { en: "A spider shoots a web at you!", zh: "蜘蛛向你射出了蛛网！" },
  mimicReveal: { en: "It's a mimic!", zh: "是拟态怪！" },
  vampireDrain: { en: (hp: number) => `The vampire drains ${hp} HP!`, zh: (hp: number) => `吸血鬼吸取了${hp}点生命！` },
  crystalReflect: { en: (dmg: number) => `Crystal reflects ${dmg} damage!`, zh: (dmg: number) => `水晶反射了${dmg}点伤害！` },
  mushroomCloud: { en: "A poison cloud erupts!", zh: "毒云爆发了！" },
  emberExplode: { en: "The ember sprite explodes!", zh: "余烬精灵爆炸了！" },
  necromancerSummon: { en: "The necromancer raises a skeleton!", zh: "死灵法师召唤了骷髅！" },
  cultistHeal: { en: (name: string, hp: number) => `The cultist heals the ${name}. (+${hp} HP)`, zh: (name: string, hp: number) => `邪教徒治疗了${name}。(+${hp} 生命)` },
  spiderQueenSummon: { en: "The spider queen spawns spiders!", zh: "蜘蛛女王孵化了蜘蛛！" },
  spiderQueenPoison: { en: "The spider queen's venom courses through you!", zh: "蜘蛛女王的毒液侵入了你！" },
  necroLordBlind: { en: "Dark magic clouds your vision!", zh: "黑暗魔法蒙蔽了你的视野！" },
  necroLordSummon: { en: "The necromancer lord summons a wraith!", zh: "死灵领主召唤了冤魂！" },
  necroLordTeleport: { en: "The necromancer lord teleports away!", zh: "死灵领主传送走了！" },
  drinkSpeed: { en: "You feel incredibly fast!", zh: "你感觉快如闪电！" },
  drinkInvisibility: { en: "You fade from sight!", zh: "你从视野中消失了！" },
  useProtection: { en: "A protective aura surrounds you! (+3 DEF)", zh: "保护光环围绕着你！(+3 防御)" },
  ringRegen: { en: "The ring pulses with healing energy. (+1 HP)", zh: "戒指散发出治愈能量。(+1 生命)" },
  petEvolve: { en: (name: string) => `Your pet evolved into a ${name}!`, zh: (name: string) => `你的宠物进化为${name}了！` },
  petBark: { en: "Your pet barks fiercely! Enemies flee!", zh: "你的宠物猛烈吠叫！敌人逃散！" },
  petPounce: { en: (target: string, dmg: number) => `Your pet pounces on the ${target} for ${dmg} damage!`, zh: (target: string, dmg: number) => `你的宠物扑向${target}，造成${dmg}点伤害！` },
  petRevive: { en: "The phoenix feather glows! Your pet revives!", zh: "凤凰羽毛发光了！你的宠物复活了！" },
  petCommandChange: { en: (cmd: string) => `Pet command: ${cmd}`, zh: (cmd: string) => `宠物指令：${cmd}` },
  langToggle: { en: "F1: 中文", zh: "F1: English" },
  helpTitle: { en: "HELP", zh: "帮助" },
  helpClose: { en: "? close   Tab switch page", zh: "? 关闭   Tab 切换页面" },
  helpPageControls: { en: "Controls", zh: "操作" },
  helpPageSymbols: { en: "Symbols", zh: "图例" },
  helpControls: {
    en: [
      "Move:  Arrow keys / h j k l",
      "Diagonal:  y u b n",
      "Wait:  Space / .",
      "Descend stairs:  >    Ascend stairs:  <",
      "Pick up:  g",
      "Inventory:  i",
      "Auto-explore:  x",
      "Restart:  R",
      "Toggle language:  F1",
      "Help:  ?",
      "Pet command:  c",
      "",
      "Descend 10 floors, find the Amulet, and ascend to win.",
      "Walk into monsters to attack. Press g to pick up items.",
      "Jack the dog follows you and heals itself.",
    ],
    zh: [
      "移动：方向键 / h j k l",
      "斜向移动：y u b n",
      "等待：空格 / .",
      "下楼梯：>    上楼梯：<",
      "拾取物品：g",
      "背包：i",
      "自动探索：x",
      "重新开始：R",
      "切换语言：F1",
      "帮助：?",
      "宠物指令：c",
      "",
      "下到第10层找到护身符，然后返回地面即可获胜。",
      "走向怪物即可攻击。按g拾取物品。",
      "宠物狗Jack会跟随你并自我治愈。",
    ],
  },
  helpSymbols: {
    en: [
      { char: "@", color: "#ffd700", desc: "You — adventurer" },
      { char: "d", color: "#f4a460", desc: "Jack — pet dog" },
      { char: "r", color: "#a0522d", desc: "Rat" },
      { char: "g", color: "#3cb371", desc: "Goblin — flees low HP" },
      { char: "s", color: "#9b59b6", desc: "Snake — poison" },
      { char: "O", color: "#e67e22", desc: "Ogre — knockback" },
      { char: "G", color: "#5a7a9a", desc: "Ghost — pass walls" },
      { char: "a", color: "#c0392b", desc: "Archer — ranged" },
      { char: "S", color: "#27ae60", desc: "Slime — splits" },
      { char: "D", color: "#ff4444", desc: "Dragon — bleed" },
      { char: "L", color: "#9933ff", desc: "Lich — summons, blind" },
      { char: "z", color: "#cccccc", desc: "Skeleton — reassembles" },
      { char: "W", color: "#6a0dad", desc: "Wraith — drains max HP" },
      { char: "f", color: "#ff4500", desc: "Fire Imp — ranged fire" },
      { char: "h", color: "#8a8a8a", desc: "Wolf — pack bonus" },
      { char: "x", color: "#d3d3d3", desc: "Spider — webs" },
      { char: "M", color: "#cd853f", desc: "Mimic — disguise" },
      { char: "T", color: "#8b8682", desc: "Golem — slow, tough" },
      { char: "V", color: "#8b0000", desc: "Vampire — life steal" },
      { char: "B", color: "#999999", desc: "Bat — double attack" },
      { char: "N", color: "#6a0dad", desc: "Necromancer — summon" },
      { char: "u", color: "#7d5fff", desc: "Cultist — heals allies" },
      { char: "H", color: "#2e8b57", desc: "Hydra — regen" },
      { char: "E", color: "#ff6347", desc: "Ember Sprite — explodes" },
      { char: "P", color: "#b0c4de", desc: "Phantom — teleport" },
      { char: "Q", color: "#8b4513", desc: "Spider Queen — boss" },
      { char: "K", color: "#4b0082", desc: "Necro Lord — boss" },
      { char: "=", color: "#2ecc71", desc: "Ring" },
      { char: "!", color: "#ff69b4", desc: "Potion" },
      { char: ")", color: "#cccccc", desc: "Weapon" },
      { char: "[", color: "#8b6914", desc: "Armor" },
      { char: "?", color: "#daa520", desc: "Scroll" },
      { char: "/", color: "#c0c0c0", desc: "Throwing knife" },
      { char: "o", color: "#ff8844", desc: "Bomb — explosive throw" },
      { char: "%", color: "#cd853f", desc: "Food" },
      { char: '"', color: "#ffd700", desc: "Amulet of Yendor" },
      { char: "~", color: "#4488cc", desc: "Water — slow" },
      { char: '"', color: "#2d6b2d", desc: "Grass — hide" },
    ],
    zh: [
      { char: "@", color: "#ffd700", desc: "你——冒险者" },
      { char: "d", color: "#f4a460", desc: "Jack——宠物狗" },
      { char: "r", color: "#a0522d", desc: "老鼠" },
      { char: "g", color: "#3cb371", desc: "哥布林——低血逃跑" },
      { char: "s", color: "#9b59b6", desc: "蛇——中毒" },
      { char: "O", color: "#e67e22", desc: "食人魔——击退" },
      { char: "G", color: "#5a7a9a", desc: "幽灵——穿墙" },
      { char: "a", color: "#c0392b", desc: "弓箭手——远程" },
      { char: "S", color: "#27ae60", desc: "史莱姆——分裂" },
      { char: "D", color: "#ff4444", desc: "巨龙——流血" },
      { char: "L", color: "#9933ff", desc: "巫妖——召唤、致盲" },
      { char: "z", color: "#cccccc", desc: "骷髅——重组" },
      { char: "W", color: "#6a0dad", desc: "冤魂——吸取生命" },
      { char: "f", color: "#ff4500", desc: "火焰小鬼——远程火攻" },
      { char: "h", color: "#8a8a8a", desc: "狼——群狼加成" },
      { char: "x", color: "#d3d3d3", desc: "蜘蛛——蛛网" },
      { char: "M", color: "#cd853f", desc: "拟态怪——伪装" },
      { char: "T", color: "#8b8682", desc: "魔像——迟缓、坚韧" },
      { char: "V", color: "#8b0000", desc: "吸血鬼——吸血" },
      { char: "B", color: "#999999", desc: "蝙蝠——双重攻击" },
      { char: "N", color: "#6a0dad", desc: "死灵法师——召唤" },
      { char: "u", color: "#7d5fff", desc: "邪教徒——治疗盟友" },
      { char: "H", color: "#2e8b57", desc: "多头蛇——再生" },
      { char: "E", color: "#ff6347", desc: "余烬精灵——爆炸" },
      { char: "P", color: "#b0c4de", desc: "幻影——传送" },
      { char: "Q", color: "#8b4513", desc: "蜘蛛女王——首领" },
      { char: "K", color: "#4b0082", desc: "死灵领主——首领" },
      { char: "=", color: "#2ecc71", desc: "戒指" },
      { char: "!", color: "#ff69b4", desc: "药水" },
      { char: ")", color: "#cccccc", desc: "武器" },
      { char: "[", color: "#8b6914", desc: "护甲" },
      { char: "?", color: "#daa520", desc: "卷轴" },
      { char: "/", color: "#c0c0c0", desc: "飞刀" },
      { char: "o", color: "#ff8844", desc: "炸弹——范围爆炸投掷" },
      { char: "%", color: "#cd853f", desc: "食物" },
      { char: '"', color: "#ffd700", desc: "延多护身符" },
      { char: "~", color: "#4488cc", desc: "水——减速" },
      { char: '"', color: "#2d6b2d", desc: "草地——隐蔽" },
    ],
  },
} as const;

// Monster & item name translations
const names: Record<string, { en: string; zh: string }> = {
  rat: { en: "rat", zh: "老鼠" },
  goblin: { en: "goblin", zh: "哥布林" },
  snake: { en: "snake", zh: "蛇" },
  ogre: { en: "ogre", zh: "食人魔" },
  "health potion": { en: "health potion", zh: "生命药水" },
  whetstone: { en: "whetstone", zh: "磨刀石" },
  "Amulet of Yendor": { en: "Amulet of Yendor", zh: "延多护身符" },
  jack: { en: "Jack", zh: "Jack" },
  "short sword": { en: "short sword", zh: "短剑" },
  "long sword": { en: "long sword", zh: "长剑" },
  "leather armor": { en: "leather armor", zh: "皮甲" },
  "chain mail": { en: "chain mail", zh: "锁子甲" },
  "scroll of teleport": { en: "scroll of teleport", zh: "传送卷轴" },
  "scroll of identify": { en: "scroll of identify", zh: "鉴定卷轴" },
  "throwing knife": { en: "throwing knife", zh: "飞刀" },
  bomb: { en: "bomb", zh: "炸弹" },
  ration: { en: "ration", zh: "口粮" },
  ghost: { en: "ghost", zh: "幽灵" },
  archer: { en: "archer", zh: "弓箭手" },
  slime: { en: "slime", zh: "史莱姆" },
  "small slime": { en: "small slime", zh: "小史莱姆" },
  dragon: { en: "dragon", zh: "巨龙" },
  lich: { en: "lich", zh: "巫妖" },
  skeleton: { en: "skeleton", zh: "骷髅" },
  "dragon scale": { en: "dragon scale", zh: "龙鳞甲" },
  wraith: { en: "wraith", zh: "冤魂" },
  "fire imp": { en: "fire imp", zh: "火焰小鬼" },
  shopkeeper: { en: "shopkeeper", zh: "店主" },
  "potion of strength": { en: "potion of strength", zh: "力量药水" },
  "potion of poison": { en: "potion of poison", zh: "毒药" },
  "scroll of enchant": { en: "scroll of enchant", zh: "附魔卷轴" },
  "scroll of mapping": { en: "scroll of mapping", zh: "地图卷轴" },
  "scroll of remove curse": { en: "scroll of remove curse", zh: "解咒卷轴" },
  // Disguise labels for unidentified items
  "red potion": { en: "red potion", zh: "红色药水" },
  "blue potion": { en: "blue potion", zh: "蓝色药水" },
  "green potion": { en: "green potion", zh: "绿色药水" },
  "pink potion": { en: "pink potion", zh: "粉色药水" },
  "black potion": { en: "black potion", zh: "黑色药水" },
  "white potion": { en: "white potion", zh: "白色药水" },
  "yellow potion": { en: "yellow potion", zh: "黄色药水" },
  "purple potion": { en: "purple potion", zh: "紫色药水" },
  "charred scroll": { en: "charred scroll", zh: "烧焦的卷轴" },
  "tattered scroll": { en: "tattered scroll", zh: "破旧的卷轴" },
  "glowing scroll": { en: "glowing scroll", zh: "发光的卷轴" },
  "ancient scroll": { en: "ancient scroll", zh: "古老的卷轴" },
  "damp scroll": { en: "damp scroll", zh: "潮湿的卷轴" },
  "faded scroll": { en: "faded scroll", zh: "褪色的卷轴" },
  "ornate scroll": { en: "ornate scroll", zh: "华丽的卷轴" },
  "dusty scroll": { en: "dusty scroll", zh: "落灰的卷轴" },
  wolf: { en: "wolf", zh: "狼" },
  spider: { en: "spider", zh: "蜘蛛" },
  mimic: { en: "mimic", zh: "拟态怪" },
  golem: { en: "golem", zh: "魔像" },
  vampire: { en: "vampire", zh: "吸血鬼" },
  mushroom: { en: "mushroom", zh: "蘑菇怪" },
  "crystal elemental": { en: "crystal elemental", zh: "水晶元素" },
  bat: { en: "bat", zh: "蝙蝠" },
  necromancer: { en: "necromancer", zh: "死灵法师" },
  cultist: { en: "cultist", zh: "邪教徒" },
  hydra: { en: "hydra", zh: "多头蛇" },
  "ember sprite": { en: "ember sprite", zh: "余烬精灵" },
  phantom: { en: "phantom", zh: "幻影" },
  "spider queen": { en: "spider queen", zh: "蜘蛛女王" },
  "necromancer lord": { en: "necromancer lord", zh: "死灵领主" },
  puppy: { en: "Puppy", zh: "小狗" },
  "dire wolf": { en: "Dire Wolf", zh: "恐狼" },
  dagger: { en: "dagger", zh: "匕首" },
  "battle axe": { en: "battle axe", zh: "战斧" },
  "war hammer": { en: "war hammer", zh: "战锤" },
  "plate armor": { en: "plate armor", zh: "板甲" },
  "mithril mail": { en: "mithril mail", zh: "秘银甲" },
  "potion of speed": { en: "potion of speed", zh: "速度药水" },
  "potion of invisibility": { en: "potion of invisibility", zh: "隐身药水" },
  "scroll of protection": { en: "scroll of protection", zh: "守护卷轴" },
  "ring of regeneration": { en: "ring of regeneration", zh: "再生戒指" },
  "ring of perception": { en: "ring of perception", zh: "感知戒指" },
  "phoenix feather": { en: "phoenix feather", zh: "凤凰羽毛" },
  "orange potion": { en: "orange potion", zh: "橙色药水" },
  "silver potion": { en: "silver potion", zh: "银色药水" },
};

export function t(key: keyof typeof strings): any {
  return (strings[key] as any)[currentLang];
}

export function name(id: string): string {
  return names[id]?.[currentLang] ?? id;
}
